import { Reducer, Action } from 'redux'
import { ICommodity, ICommodityState } from 'types/carrier'
import {
  CARRIER_COMMODITIES_ACTION_TYPE,
  EDIT_CARRIER_COMMODITIES_ACTION_TYPE,
  COMMODITIES_DIALOG_ACTION_TYPES,
} from 'utils/actions/carrier'

const {
  CARRIER_COMMODITIES_FAILURE,
  CARRIER_COMMODITIES_REQUEST,
  CARRIER_COMMODITIES_SUCCESS,
} = CARRIER_COMMODITIES_ACTION_TYPE
const {
  EDIT_CARRIER_COMMODITIES_FAILURE,
  EDIT_CARRIER_COMMODITIES_REQUEST,
  EDIT_CARRIER_COMMODITIES_SUCCESS,
} = EDIT_CARRIER_COMMODITIES_ACTION_TYPE
const { CLOSE_COMMODITIES_DIALOG, OPEN_COMMODITIES_DIALOG } = COMMODITIES_DIALOG_ACTION_TYPES

const defaultState = {
  commodities: [],
  loading: true,
  errors: undefined,
  showDialog: false,
}

interface SuccessAction extends Action<string> {
  payload: {
    coveredCommodities: ICommodity[]
  }
}
interface FailureAction extends Action<string> {
  error: string
}

type CarrierCommoditiesReducerAction = Action<string> | SuccessAction | FailureAction

const carrierCommoditiesReducer: Reducer<ICommodityState, CarrierCommoditiesReducerAction> = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case CARRIER_COMMODITIES_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case CARRIER_COMMODITIES_SUCCESS: {
      const {
        payload: { coveredCommodities },
      } = action as SuccessAction
      return {
        ...state,
        commodities: coveredCommodities,
        loading: false,
        errors: undefined,
      }
    }
    case CARRIER_COMMODITIES_FAILURE: {
      const { error } = action as FailureAction
      return {
        ...state,
        commodities: [],
        loading: false,
        error,
      }
    }
    case EDIT_CARRIER_COMMODITIES_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case EDIT_CARRIER_COMMODITIES_SUCCESS: {
      const {
        payload: { coveredCommodities },
      } = action as SuccessAction
      return {
        ...state,
        commodities: coveredCommodities,
        loading: false,
        errors: undefined,
        showDialog: false,
      }
    }
    case EDIT_CARRIER_COMMODITIES_FAILURE: {
      const { error } = action as FailureAction
      return {
        ...state,
        loading: false,
        error,
      }
    }
    case OPEN_COMMODITIES_DIALOG:
      return {
        ...state,
        showDialog: true,
      }
    case CLOSE_COMMODITIES_DIALOG:
      return {
        ...state,
        showDialog: false,
      }
    default:
      return state
  }
}

export default carrierCommoditiesReducer
